// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.widget-rootwidget .dropdown-item:active {\n  color: #fff !important;\n}\n.btn-blue button {\n  color: #007afd !important;\n}\n", ""]);
// Exports
module.exports = exports;
